import { useAuthContext } from "providers/Auth";
import { useNavigate } from "react-router-dom";

import { getErrorMessage } from "utils/error";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Plus } from "untitledui-js-base";
import { toast } from "react-toastify";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const LayoutButtons = () => {
  const dictionary = useUnitsPropertiesDictionary();
  const { partner, type, permissions } = useAuthContext();
  const navigate = useNavigate();

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(
        // @ts-expect-error
        partner?.magic_link?.application_link
      );
      toast.info("Link copied");
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  };

  if (type.isBoomScreen && permissions.canManageProperties)
    return (
      <>
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          onClick={handleCopyLink}
          className="w-full"
        >
          Copy Portfolio Link
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          onClick={() => navigate("/properties/add")}
          Icon={Plus}
          className="w-full"
        >
          Add {dictionary.Property}
        </Button>
      </>
    );

  if (type.isBoomScreen)
    return (
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={handleCopyLink}
      >
        Copy Portfolio Link
      </Button>
    );

  if (permissions.canManageProperties)
    return (
      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={() => navigate("/properties/add")}
        Icon={Plus}
      >
        Add {dictionary.Property}
      </Button>
    );

  return null;
};
